// extracted by mini-css-extract-plugin
export default {"bankDetailsForm":"AddBankDetails__bankDetailsForm-5DJ0","error":"AddBankDetails__error-s74D"};